import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getFacilities = async (searchString, managerIds, brokerIds) => {
  const data = await request.get(
    `/RentPlace/rental_house`,
    { searchString, managerIds, brokerIds },
    'При загрузке объектов произошла ошибка',
    []
  );
  return data.sort((a, b) => a.orderNum - b.orderNum);
};

const useFacilities = (searchString, managerIds, brokerIds) =>
  useQuery(
    [queries.facilities, searchString, managerIds, brokerIds],
    () => getFacilities(searchString || undefined, managerIds, brokerIds),
    {
      placeholderData: [],
    }
  );

export default useFacilities;
